import { type CountryCode, type Option } from 'ecosystem'

/**
 * The country a PSP session is created for: the shopper's pick when the
 * merchant offers a choice and the pick is one of the offered ones, otherwise
 * the merchant's configured country.
 *
 * An empty or absent `availableCountries` means the merchant offers no country
 * selector, so any pick is honoured — that is the pre-existing behaviour of all
 * four providers this replaces. A session that must ignore the pick entirely
 * (Nexi, bound to one market) never calls this.
 *
 * VAT does *not* follow this value: the order lines stay on the configured
 * country, which is why the two are threaded separately through the pipeline.
 */
export const resolveSessionCountry = <TCountry extends string>(
  requested: CountryCode | undefined,
  {
    availableCountries,
    fallback
  }: { availableCountries?: Option<CountryCode[]> | undefined; fallback?: TCountry }
): TCountry | CountryCode | undefined => {
  if (requested && (!availableCountries?.length || availableCountries.includes(requested))) {
    return requested
  }

  return fallback
}
